<div class="p-5 table-cont">
    <h2 class="primary text-center fw-bold">Azioni massive</h2>
    <div class="card card-ks">
        <app-filter-bar [filterFieldMap]="filters" (filtersChanged)="onFilterChanged($event)"></app-filter-bar>
        <div class="massive-actions-bar row">
            <div class="col-10 d-flex justify-content-between">
                <div class="d-flex gap-3 align-items-center">
                    <input type="radio" id="extend-license" name="massive-actions-radio" [(ngModel)]="selectedOption"
                        value="extend">
                    <label class="cursor-pointer" for="extend-license">
                        Prolunga licenza
                    </label>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <input type="radio" id="enable-license" name="massive-actions-radio" [(ngModel)]="selectedOption"
                        value="enable">
                    <label class="cursor-pointer" for="enable-license">
                        Abilita attestati
                    </label>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <input type="radio" id="disable-license" name="massive-actions-radio" [(ngModel)]="selectedOption"
                        value="disable">
                    <label class="cursor-pointer" for="disable-license">
                        Disabilita attestati
                    </label>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <input type="radio" id="download-license" name="massive-actions-radio" [(ngModel)]="selectedOption"
                        value="download">
                    <label class="cursor-pointer" for="download-license">
                        Scarica attestati
                    </label>
                </div>
            </div>
            <div class="col-2 d-flex justify-content-end">
                <button type="submit" class="btn btn-primary-ks" [disabled]="!selectedOption()"
                    (click)="applyMassiveActions()">Applica</button>
            </div>
        </div>
        <div class="table-responsive featured-div-table">
            <app-spinner></app-spinner>
            <table class="table featured-table" id="table-courses">
                <thead>
                    <tr>
                        <th scope="col">
                            <input type="checkbox" class="form-check-input checkbox-large"
                                [checked]="isAllCurrentPageSelected" [indeterminate]="isSomeCurrentPageSelected"
                                (change)="toggleSelectAll()">
                        </th>
                        @if(isAdmin()){
                        <th scope="col">
                            Rivenditore
                        </th>
                        }
                        <th scope="col">
                            Corso
                        </th>
                        <th scope="col">
                            Cliente
                        </th>
                        <th scope="col">
                            Nominativo
                        </th>
                        <th scope="col">
                            Codice
                        </th>
                        <th scope="col" class="text-center">
                            Stato
                        </th>
                        <th scope="col" class="text-center">
                            Scadenza
                        </th>
                        <th scope="col" class="text-center">
                            Avanzamento
                        </th>
                        <th scope="col" class="text-center">
                            Attivazione
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @if(licenseList().length > 0){
                    @for(lic of licenseList(); track lic.licenseId){
                    <tr>
                        <td class="learner-license-selected">
                            <input type="checkbox" class="form-check-input checkbox-large"
                                [checked]="isLicenseSelected(lic.licenseId)" (change)="toggleLicenseSelection(lic)">
                        </td>
                        @if(isAdmin()){
                        <td class="learner-license-reseller">
                            {{ lic.resellerCompany }}
                        </td>
                        }
                        <td class="learner-license-course">
                            {{ lic.courseTitle }}
                        </td>
                        <td class="learner-license-client">
                            {{lic.clientBusinessName}}
                        </td>
                        <td class="learner-license-name">
                            {{lic.learnerFullname || 'Non assegnato'}}
                        </td>
                        <td class="learner-license-code">
                            {{lic.licenseCode}}
                        </td>
                        <td class="learner-license-status text-center">
                            @if(lic.isBlocked) {
                            <span class="badge deactivated-badge">Disattivo</span>
                            }
                            @else if(lic.userIsActive == false){
                            <span class="badge deactivated-badge">Discente bloccato</span>
                            }
                            @else {
                            @if(lic.status === status.ATTIVO) {
                            <span class="badge active-badge">Attivo</span>
                            }
                            @else if(lic.status === status.ATTIVABILE) {
                            <span class="badge activable-badge">Attivabile</span>
                            }
                            @else if(lic.status === status.DOWNLOAD) {
                            <span class="badge download-badge">Download</span>
                            }
                            }
                        </td>
                        <td class="learner-license-start-date text-center">
                            {{ lic.expirationDate ? (lic.expirationDate | date:'dd/MM/yyyy') : 'Licenza non attivata' }}
                        </td>
                        <td class="learner-license-progress-bar">
                            <app-progress-bar [license]="lic"></app-progress-bar>
                        </td>
                        <td class="learner-license-start-date text-center">
                            {{lic.activationDate | date:'dd/MM/yyyy'}}
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
            @if(licenseList().length === 0){
            <p class="text-center">Non sono presenti elementi in tabella</p>
            }
            <app-custom-pagination [currentPage]="currentPage()" [totalItems]="totalItems()"
                [itemsPerPage]="itemsPerPage()" [totalPages]="totalPages()" (pageChanged)="onPagedItemsChange($event)"
                (itemsPerPageChanged)="onPageSizeChanged($event)">
            </app-custom-pagination>
        </div>
    </div>
</div>